import { Navigate } from 'react-router-dom';

// Page « Relances client » fusionnée dans « Tâches ».
// On garde la route pour que les anciens liens (notifications déjà émises,
// bookmarks) redirigent automatiquement vers Tâches.
export default function Relances() {
  return <Navigate to="../taches" replace />;
}
